export default function EFConsumption() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                d="M7.04688 20.8327L20.0003 10.7578L32.9538 20.8327V30.9076C32.9538 31.6711 32.6505 32.4032 32.1107 32.9431C31.5708 33.4829 30.8387 33.7862 30.0752 33.7862H24.3181V23.7113H15.6825V33.7862H9.92542C9.16198 33.7862 8.42981 33.4829 7.88998 32.9431C7.35015 32.4032 7.04688 31.6711 7.04688 30.9076V20.8327Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.898 5.31685C20.3723 4.89633 19.6254 4.89634 19.0998 5.31685L5.26898 16.3815C4.95863 16.6298 4.90831 17.0826 5.15659 17.393L6.0557 18.5169C6.30398 18.8272 6.75684 18.8775 7.06719 18.6292L19.5493 8.64355C19.8121 8.43329 20.1856 8.43329 20.4484 8.64355L32.9305 18.6292C33.2409 18.8775 33.6938 18.8272 33.942 18.5169L34.8412 17.393C35.0894 17.0826 35.0391 16.6298 34.7288 16.3815L31.5151 13.8105V7.15998C31.5151 6.76253 31.1929 6.44034 30.7955 6.44034L27.9169 6.44034C27.5195 6.44034 27.1973 6.76253 27.1973 7.15998V10.3563L20.898 5.31685Z"
                fill="white"
            />
        </svg>
    );
}
